"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Layout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const de_ui_1 = require("@delab-team/de-ui");
const react_1 = require("@nanostores/react");
const navFooter_1 = require("../components/navFooter");
const stores_1 = require("../stores");
const layout_module_css_1 = __importDefault(require("./layout.module.css"));
const Layout = ({ children, isLoading, setShowJettonDetail, showJettonDetail }) => {
    const location = (0, react_router_dom_1.useLocation)();
    const { storeMain } = (0, stores_1.useStores)();
    const storeThemeRepository = (0, react_1.useStore)(storeMain.repository);
    // const ref = useRef<HTMLDivElement | null>(null)
    // useEffect(() => {
    //     if (ref.current) {
    //         ref.current.scrollTop = 0
    //     }
    // }, [ window.location.pathname, ref.current ])
    // useEffect(() => {
    //     window.scrollTo(0, 0)
    // }, [ window.location.pathname ])
    // useEffect(() => {
    //     // Прокрутка в верхнее положение при изменении маршрута
    //     document.body.scrollTop = 0
    //     // document.documentElement.scrollTop = 0
    // }, [ location.pathname ])
    // useEffect(() => {
    //     console.log('location.pathname', location.pathname)
    //     // const scrollToElement = document.body
    //     // scrollToElement.scrollIntoView({ behavior: 'smooth' })
    //     window.document.body.scrollTo(0, 0)
    // }, [ location.pathname ])
    return ((0, jsx_runtime_1.jsx)(de_ui_1.PageWrapper, { className: `${layout_module_css_1.default.wrapper} ${(location.pathname === '/reg' || location.pathname === '/tonconnect' || isLoading) ? layout_module_css_1.default.wrapperReg : null}`, headerClassName: layout_module_css_1.default.wrapperHeader, containerWidth: "500px", header: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), footer: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), pageTitle: "DeWallet", content: (0, jsx_runtime_1.jsxs)("div", { className: layout_module_css_1.default.content, children: [children, (location.pathname !== '/changepsw' && location.pathname !== '/reg' && !isLoading && location.pathname !== '/tonconnect' && (location.pathname !== '/qr') && (storeThemeRepository.showNavigation === true)) && (0, jsx_runtime_1.jsx)(navFooter_1.NavFooter, { setShowJettonDetail: setShowJettonDetail, showJettonDetail: showJettonDetail })] }) })
    // <div
    //     className={`${s.wrapper} ${(location.pathname === '/reg' || location.pathname === '/tonconnect' || isLoading) ? s.wrapperReg : null}`}
    //     ref={ref}
    // >
    //     <div className={s.content}>
    //         {children}
    //         {(location.pathname !== '/reg' && !isLoading && location.pathname !== '/tonconnect' && (location.pathname !== '/qr') && (storeThemeRepository.showNavigation === true)) && <NavFooter setShowJettonDetail={setShowJettonDetail} showJettonDetail={showJettonDetail} />}
    //     </div>
    // </div>
    );
};
exports.Layout = Layout;
